import { AccordionSection, type FormatSectionTitleFn } from 'components/common-form/sidePanel/AccordionSection';
import { FC, ReactNode } from 'react';

type Props = {
  getTitle: FormatSectionTitleFn<string>;
  content: ReactNode;
  sectionName: string;
};

export const UniqueSectionItem: FC<Props> = ({ getTitle, content, sectionName }) => {
  return (
    <AccordionSection<string>
      section={sectionName}
      showSpinners={false}
      getTitle={getTitle}
      e2e={`panel-${sectionName}`}
    >
      {content}
    </AccordionSection>
  );
};

UniqueSectionItem.displayName = 'UniqueSectionItem';
